module.exports = __webpack_public_path__ + "media/images/flags/1x1/guy-701984f69e0fa3ab9d247a3d5b4adc15.svg";